// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"TabA_TheComp__asa31","Win1":"TabA_Win1__Iyphf","Win3":"TabA_Win3__SxNby"};